import { render } from "./modiRiseModel.vue?vue&type=template&id=139abebf"
import script from "./modiRiseModel.vue?vue&type=script&lang=js"
export * from "./modiRiseModel.vue?vue&type=script&lang=js"

import "./modiRiseModel.vue?vue&type=style&index=0&id=139abebf&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__